import useQueryState from '@discover-use-query-state';
import DEFAULT_SORT from '@discover-data/stores/restaurant/model/sort/default';
import getValidSort from './getValid';
import { sortValues } from './sortOptions';

export default function useSortQueryState() {
  return useQueryState('sort', (values) => getValidSort(values, sortValues), DEFAULT_SORT);
}
